import { __exports as util } from "../../../../../../../_virtual/index6.js";
import { __require as requireUnesc } from "./unesc.js";
import { __require as requireGetProp } from "./getProp.js";
import { __require as requireEnsureObject } from "./ensureObject.js";
import { __require as requireStripComments } from "./stripComments.js";
var hasRequiredUtil;
function requireUtil() {
  if (hasRequiredUtil) return util;
  hasRequiredUtil = 1;
  util.__esModule = true;
  util.unesc = util.stripComments = util.getProp = util.ensureObject = void 0;
  var _unesc = _interopRequireDefault(requireUnesc());
  util.unesc = _unesc["default"];
  var _getProp = _interopRequireDefault(requireGetProp());
  util.getProp = _getProp["default"];
  var _ensureObject = _interopRequireDefault(requireEnsureObject());
  util.ensureObject = _ensureObject["default"];
  var _stripComments = _interopRequireDefault(requireStripComments());
  util.stripComments = _stripComments["default"];
  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { "default": obj };
  }
  return util;
}
export {
  requireUtil as __require
};
//# sourceMappingURL=index.js.map
